import siteVerificationStore from '@Modules/cms/stores/siteVerification';
import allocationStore from '@Modules/offer/stores/allocation';
import publisherStore from '@Modules/offer/stores/publisher';

import BaseReportStore from './base-store'

export default new class SiteVerificationStore extends BaseReportStore {
  constructor() {
    super(true)
  }

  endpointReport = 'site-verification'

  publisher = this.attachEntity(publisherStore)
  allocation = this.attachEntity(allocationStore, { labelKey: 'description' })
  verification = this.attachEntity(siteVerificationStore)
}
